import { useState, useEffect } from 'react';

export const useMobileDetection = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [screenSize, setScreenSize] = useState<'mobile' | 'tablet' | 'desktop'>('desktop');

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      const userAgent = navigator.userAgent.toLowerCase();
      
      // Определяем мобильное устройство по ширине экрана и user agent
      const mobileCheck = width <= 768 || 
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
      
      // Определяем планшет
      const tabletCheck = width > 768 && width <= 1024 && 
        /ipad|android|tablet/i.test(userAgent);
      
      setIsMobile(mobileCheck);
      setIsTablet(tabletCheck);
      
      if (mobileCheck) {
        setScreenSize('mobile');
      } else if (tabletCheck) {
        setScreenSize('tablet');
      } else {
        setScreenSize('desktop');
      }
    };

    // Проверяем при загрузке
    checkDevice();

    // Слушаем изменения размера окна
    window.addEventListener('resize', checkDevice);
    
    // Очищаем слушатель при размонтировании
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  return {
    isMobile,
    isTablet,
    isDesktop: !isMobile && !isTablet,
    screenSize,
    isMobileOrTablet: isMobile || isTablet
  };
};
